<div class="premium-modal-wrapper">
  <ion-header class="ion-no-border premium-header">
    <div class="header-curve"></div>
    <div class="custom-toolbar">
      <div class="toolbar-content">
        <div class="icon-btn" (click)="close()">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </div>
        <div class="title-group">
          <div class="title-main">{{ gastoActual.id > 0 ? 'Editar Gasto' : 'Nuevo Gasto' }}</div>
          <div class="title-sub">Completa los detalles del registro</div>
        </div>
      </div>
    </div>
  </ion-header>

  <ion-content>
    <div class="form-wrapper">
      <div class="form-card">
        <!-- Fecha & Monto -->
        <div class="grid-inputs">
          <div class="input-group">
            <label><ion-icon name="calendar-outline"></ion-icon> Fecha</label>
            <div class="premium-input-wrapper date-input">
              <input type="date" [(ngModel)]="gastoActual.fecha" #dateInput>
              <ion-icon name="calendar-outline" class="date-icon" (click)="dateInput.showPicker()"></ion-icon>
            </div>
          </div>

          <div class="input-group">
            <label><ion-icon name="cash-outline"></ion-icon> Monto ($)</label>
            <div class="premium-input-wrapper positive">
              <input type="number" [(ngModel)]="gastoActual.monto" placeholder="0.00">
            </div>
          </div>
        </div>

        <!-- Lugar & Categoría -->
        <div class="input-group full">
          <label><ion-icon name="location-outline"></ion-icon> Lugar</label>
          <div class="autocomplete-wrapper">
            <div class="premium-input-wrapper">
              <input type="text" [(ngModel)]="gastoActual.lugar" (input)="filterLugares($event)"
                (focus)="showAllLugares()" placeholder="Lugar de compra">
              <div class="ac-actions" style="display: flex; align-items: center; gap: 8px;">
                <ion-icon name="close-circle" class="ac-clear" *ngIf="gastoActual.lugar"
                  (click)="clearLugar()"></ion-icon>
                <ion-icon name="chevron-down-outline" class="ac-dropdown-icon"
                  style="font-size: 0.9rem; color: #94a3b8;" (click)="toggleLugarDropdown($event)"></ion-icon>
              </div>
            </div>
            <div class="ac-dropdown" *ngIf="showLugarDropdown">
              <div class="ac-item" *ngFor="let loc of filteredLugares" (click)="selectLugar(loc)">
                <ion-icon name="location-outline"></ion-icon>
                {{ loc.nombre || loc }}
              </div>
              <div class="ac-item ac-create" *ngIf="showCreateLugarOption" (click)="createComercio()">
                <ion-icon name="add-circle-outline"></ion-icon>
                Crear "{{ gastoActual.lugar }}"
              </div>
            </div>
          </div>
        </div>

        <div class="input-group full">
          <label><ion-icon name="pricetag-outline"></ion-icon> Categorías</label>
          
          <!-- Chips de categorías seleccionadas -->
          <div class="selected-categories-container" *ngIf="selectedCategorias.length > 0">
            <span class="category-chip" *ngFor="let cat of selectedCategorias" [class.chip-ia]="cat.toLowerCase() === 'ia'">
              <ion-icon name="pricetag-outline" class="chip-icon"></ion-icon>
              <span>{{ cat }}</span>
              <ion-icon name="close-circle" class="chip-remove" (click)="removeCategoria(cat, $event)"></ion-icon>
            </span>
          </div>

          <div class="autocomplete-wrapper">
            <div class="premium-input-wrapper">
              <input type="text" [(ngModel)]="inputTipo" (input)="filterTipos($event)" (focus)="showAllTipos()"
                placeholder="Agregar otra categoría...">
              <div class="ac-actions" style="display: flex; align-items: center; gap: 8px;">
                <ion-icon name="close-circle" class="ac-clear" *ngIf="inputTipo"
                  (click)="clearTipo()"></ion-icon>
                <ion-icon name="chevron-down-outline" class="ac-dropdown-icon"
                  style="font-size: 0.9rem; color: #94a3b8;" (click)="toggleTipoDropdown($event)"></ion-icon>
              </div>
            </div>
            <div class="ac-dropdown" *ngIf="showTipoDropdown">
              <div class="ac-item" *ngFor="let t of filteredTipos" (click)="selectTipo(t)">
                <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
                  <div style="display: flex; align-items: center; gap: 8px;">
                    <ion-icon name="pricetag-outline"></ion-icon>
                    <span>{{ t.nombre || t }}</span>
                  </div>
                  <ion-icon name="checkmark-circle" *ngIf="isCategoriaSelected(t.nombre || t)" style="color: #10b981; font-size: 1.1rem;"></ion-icon>
                </div>
              </div>
              <div class="ac-item ac-create" *ngIf="showCreateCategoriaOption" (click)="createCategoria()">
                <ion-icon name="add-circle-outline"></ion-icon>
                Crear "{{ inputTipo }}"
              </div>
            </div>
          </div>
        </div>

        <!-- Descripción -->
        <div class="input-group full">
          <label><ion-icon name="document-text-outline"></ion-icon> Concepto / Descripción</label>
          <div class="premium-input-wrapper">
            <textarea rows="3" [(ngModel)]="gastoActual.descripcion" placeholder="Detalle del gasto..."></textarea>
          </div>
        </div>
      </div>

      <!-- Evidence Card -->
      <div class="form-card evidence-card">
        <label class="section-label"><ion-icon name="attach-outline"></ion-icon> Evidencia del Gasto</label>

        <div class="evidence-upload-box">
          <input type="file" #fileInput hidden accept="image/*,application/pdf" (change)="onFileSelected($event)">

          <!-- Delete Button para PDF -->
          <button class="remove-file-btn" *ngIf="isPdf && !loadingAttachment" (click)="removeFile($event)">
            <ion-icon name="trash-outline"></ion-icon>
          </button>

          <!-- Loading State for existing attachment -->
          <div class="upload-loading-state" *ngIf="loadingAttachment">
            <ion-spinner name="crescent" color="primary"></ion-spinner>
            <p>Cargando comprobante...</p>
          </div>

          <div class="upload-placeholder" *ngIf="archivosPreview.length === 0 && !isPdf && !loadingAttachment">
            <div class="upload-options">
              <div class="upload-option" (click)="takePhoto()">
                <div class="option-icon-wrapper camera">
                  <ion-icon name="camera-outline"></ion-icon>
                </div>
                <span>Cámara/Galería</span>
              </div>

              <div class="option-divider"></div>

              <div class="upload-option" (click)="fileInput.click()">
                <div class="option-icon-wrapper file">
                  <ion-icon name="document-attach-outline"></ion-icon>
                </div>
                <span>Archivo</span>
              </div>
            </div>
            <p class="upload-hint">JPG, PNG o PDF</p>
          </div>

          <div class="upload-preview-container" *ngIf="archivosPreview.length > 0 && !isPdf">
            <div class="upload-preview multiple" *ngFor="let preview of archivosPreview">
              <img [src]="preview" (click)="viewImage(preview)">
              <!-- Barra de acciones rápidas: esquina superior derecha -->
              <div class="quick-actions">
                <button class="qa-btn expand" (click)="viewImage(preview, false)" title="Ver">
                  <ion-icon name="expand-outline"></ion-icon>
                </button>
                <button class="qa-btn change" (click)="takePhoto()" title="Cambiar">
                  <ion-icon name="camera-reverse-outline"></ion-icon>
                </button>
                <button class="qa-btn remove" (click)="removeFile($event)" title="Eliminar">
                  <ion-icon name="trash-outline"></ion-icon>
                </button>
              </div>
            </div>
          </div>

          <!-- "Llenar formulario con IA" button -->
          <div class="ai-fill-bar" *ngIf="archivosPreview.length > 0 && !isPdf" (click)="llenarConIA()" [class.disabled]="loadingAI">
            <ion-spinner name="crescent" *ngIf="loadingAI"></ion-spinner>
            <ion-icon name="sparkles-outline" *ngIf="!loadingAI"></ion-icon>
            <span>{{ aiAttemptStatus }}</span>
          </div>

          <div class="upload-preview pdf" *ngIf="isPdf" (click)="fileInput.click()">
            <ion-icon name="document-text-outline"></ion-icon>
            <p>PDF Adjunto</p>
            <span>{{archivoName}}</span>
            <div class="preview-overlay">
              <ion-icon name="sync-outline"></ion-icon>
              <span>Remplazar PDF</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </ion-content>

  <div class="form-footer-actions">
    <ion-button *ngIf="gastoActual.id > 0" fill="outline" class="delete-modal-btn" (click)="delete()">
      <ion-icon name="trash-outline" slot="start"></ion-icon>
      Eliminar
    </ion-button>
    <ion-button *ngIf="gastoActual.id === 0" fill="outline" class="cancel-modal-btn" (click)="close()">
      <ion-icon name="close-outline" slot="start"></ion-icon>
      Cancelar
    </ion-button>
    <ion-button class="save-btn" (click)="saveGasto()" [disabled]="saving || loading">
      <ion-icon name="checkmark-done-outline" slot="start"></ion-icon>
      {{ gastoActual.id > 0 ? 'Actualizar' : 'Registrar Gasto' }}
    </ion-button>
  </div>
</div>
